

export default {
  '欢迎': {
    zh: '欢迎',
    en: 'Welcome',
    ar: '',
    fa: ''
  },
}